export default __webpack_public_path__ + "static/media/icon-pengaturan.8fda4ae8.png";